<template>
  <div class="gmf-countdown">
    {{ advancedString(prefixString, { countdown }) }}
  </div>
</template>

<style>
.gmf-context .gmf-countdown {
  font-weight: bold;
}
</style>

<script>
import advancedString from '@/utils/advancedString';

export default {
  name: 'Countdown',
  emits: ['done'],
  props: {
    unixTimestamp: {
      type: String,
      required: true
    },
    prefixString: {
      type: String,
    }
  },
  data() {
    return {
      countdown: ''
    };
  },
  methods: {
    advancedString,
    updateCountdown() {
      const now = new Date().getTime();
      const target = new Date(this.unixTimestamp * 1000).getTime();
      const diff = target - now;

      if (diff <= 0) {
        this.countdown = '0s';
        this.$emit('done');
        clearInterval(this.intervalId);
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      let countdownString = [];
      if (days > 0) {
        countdownString.push(`${days}d`);
      }
      if (hours > 0) {
        countdownString.push(`${hours}h`);
      }
      if (minutes > 0) {
        countdownString.push(`${minutes}m`);
      }
      countdownString.push(`${String(seconds).padStart(2, '0')}s`);

      this.countdown = countdownString.slice(0,2).join(' ');
    }
  },
  created() {
    this.updateCountdown(); // Initial call to set the countdown immediately
    this.intervalId = setInterval(this.updateCountdown, 1000);
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  }
}
</script>
